import { render, staticRenderFns } from "./ChangeScoreLockPassword.vue?vue&type=template&id=af343116&"
import script from "./ChangeScoreLockPassword.vue?vue&type=script&lang=js&"
export * from "./ChangeScoreLockPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports